import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

import DOMPurify from "dompurify";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Slider from "react-slick";
import MainMenu from "../../components/mainMenu";
import menuBg from "../../assets/images/bg/menu/home.svg";
import imageFive from "../../assets/images/about/Union.png";
import logo from "../../assets/images/logo.png";
import FooterBottom from "../../components/footerBottom";
// components
import Header from "../../components/header";
import SignupModal from "../../components/signupModal";
import { getAboutDetailsAction } from "../App/actions";
import "./style.scss";
import { prepareCProvides } from "../../utils/commonFunctions";
import TeamMember from "./teamMember";
import CustomButton from "../../components/Buttons/CustomButton";
import Cookies from "universal-cookie";

const cookie = new Cookies();

const About = (props) => {
  const isAuth = cookie.get("user_token");
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [openMenu, setOpenMenu] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [flexTitles, setFlexTitles] = useState([]);
  const [time, setTime] = useState(Date.now());
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeTitle, setActiveTitle] = useState(null);
  const [, setWidth] = useState(0);

  const {
    about: { clarity_provides_title },
  } = props;
  console.log("props: clarity", props);

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  useEffect(() => {
    if (activeIndex === flexTitles.length - 1) {
      setActiveIndex(0);
    } else {
      setActiveIndex(activeIndex + 1);
    }
  }, [time]);

  useEffect(() => {
    setActiveTitle(flexTitles[activeIndex]);
  }, [activeIndex]);

  useEffect(() => {
    setActiveIndex(0);
    setWidth(0);
    setActiveTitle(flexTitles[0]);
  }, [flexTitles]);

  useEffect(() => {
    if (props?.about?.clarity_provides_title && props?.about?.clarity_provides_title.includes("[")) {
      const _cp = prepareCProvides(props?.about?.clarity_provides_title);
      if (_cp) {
        setFlexTitles(_cp);
      }
    }
  }, [clarity_provides_title]);

  useEffect(() => {
    const timerID = setInterval(() => setTime(Date.now()), 5000);
    return () => {
      clearInterval(timerID);
    };
  }, []);

  useEffect(() => {
    props.getAboutDetailsAction();
  }, []);

  useEffect(() => {
    if (props?.about?.keywords?.length > 0) {
      const dataKeyword = props?.about?.keywords;
      const pp = dataKeyword.toString();
      setKeyword(pp);
    }
  }, [props?.about?.keywords]);

  console.log("changes");

  return (
    <>
      <Helmet>
        <title>About Dr. Logan Jones - Founder of Clarity Cooperative</title>
        <meta name="description" content={props?.about?.excerpt} />
        <meta name="title" content={"About Dr. Logan Jones - Founder of Clarity Cooperative"} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={"About Dr. Logan Jones - Founder of Clarity Cooperative"} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={props?.about?.url} />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.about?.excerpt} />
        <meta name="twitter:card" content={props?.about?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.about?.url} />
        <meta name="twitter:title" content={"About Dr. Logan Jones - Founder of Clarity Cooperative"} />
        <meta name="twitter:description" content={props?.about?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>

      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />

      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />

      <div className="main__container">
        <div className="section section1">
          <Container>
            <Row className="align-items-end">
              <Col xs="12" md={5}>
                {props?.about?.hero_image && (
                  <Row className="gx-1 align-items-end">
                    <Col xs="6" sm={5}>
                      <img className="img-fluid" src={props?.about?.hero_image[0]?.image} alt="" />
                    </Col>
                    <Col xs="6" sm>
                      <img className="img-fluid" src={props?.about?.hero_image[1]?.image} alt="" />
                    </Col>
                  </Row>
                )}
              </Col>
              <Col xs="12" lg={7}>
                <div className="ps-0 ps-md-5 py-3 text-center text-md-start">
                  <p className="w-100 fw-bold mb-3">{props?.about?.name?.toUpperCase()}</p>
                  <h2 className="mb-3">{props?.about?.hero_title}</h2>
                  <p className="w-100 mb-xl-5 mb-4 text-xxl">{props?.about?.hero_sub_title}</p>
                  {props?.about?.hero_button_title && !isAuth && (
                    <a className="expert" href={props?.about?.hero_button_link} target="_blank" rel="noreferrer">
                      <Button variant="primary">{props?.about?.hero_button_title}</Button>
                    </a>
                  )}
                </div>
              </Col>
            </Row>

            {props?.about?.hero_image && (
              <Row className="gx-1 mt-md-5">
                <Col xs="6" md={3}>
                  <img src={props?.about?.hero_image[2]?.image} className="img-fluid" alt="" />
                </Col>
                <Col xs="6" md={4}>
                  <img src={props?.about?.hero_image[3]?.image} className="img-fluid" alt="" />
                </Col>
              </Row>
            )}
          </Container>
        </div>

        <div className="section section2 position-relative bg-repeat bg-size bg-center text-white overflow-hidden">
          <Container>
            <Row>
              <Col lg={6}>
                <h2 className="mb-4">{props.about?.made_for_title}</h2>
                {/* <p>{props.about?.made_for_paragraph}</p> */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.about?.made_for_paragraph),
                  }}
                />
                {props?.about?.made_for_button_title && (
                  <a href={props?.about?.made_for_button_link} target="_blank" rel="noreferrer">
                    <CustomButton gradient variant="rainbow" className="mt-4">
                      {props?.about?.made_for_button_title}
                    </CustomButton>
                  </a>
                )}
              </Col>
            </Row>
          </Container>
          <img className="position-absolute top-50 end-0 translate-middle-y d-none d-lg-block" src={imageFive} alt="" />
        </div>

        <div className="section section10">
          <Container>
            <Row className="gy-4">
              {props?.about?.founder_image && (
                <Col lg={5} className="pe-lg-5">
                  <div className="mask__div pe-xl-4">
                    <img className="img-fluid" src={props?.about?.founder_image} alt="" />
                  </div>
                </Col>
              )}
              <Col lg={7}>
                <p className="mb-3 fw-bold">{props.about?.founder_label}</p>
                <h2>{props.about?.founder_name}</h2>
                <h5 className="mb-3 mb-md-4 mb-xl-5">{props.about?.founder_paragraph_title}</h5>
                <div className="meet-founder">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.about?.founder_paragraph),
                    }}
                  ></div>
                </div>
                <p className="text-end">
                  {props?.about?.founder_signature && <img src={props?.about?.founder_signature} className="sign" height="67px" alt="" />}
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="section section3 bg-repeat bg-size bg-center text-white">
          <Container>
            <Row className="justify-content-center text-center">
              <Col md={8} lg={7} xl={6}>
                <h2 className="mb-0">{props.about?.founder_bottom_title}</h2>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="section section4 text-center">
          <Container>
            <Row className="justify-content-center">
              <Col md={10} lg={9} xl={8}>
                <h2 className="mb-2">{props.about?.co_op_title}</h2>
                <div
                  className="meet-founder1 mb-5"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.about?.co_op_paragraph),
                  }}
                />
              </Col>
            </Row>

            <div className="px-md-4 px-lg-5">
              <Row className="gy-5 g-md-4 g-lg-5">
                <Col md={6} lg={4}>
                  <h5>{props.about?.count1}</h5>
                  <p className="mb-0">{props.about?.count1_label}</p>
                </Col>
                <Col md={6} lg={4}>
                  <h5>{props.about?.count2}</h5>
                  <p className="mb-0">{props.about?.count2_label}</p>
                </Col>
                <Col md={6} lg={4}>
                  <h5>{props.about?.count3}</h5>
                  <p className="mb-0">{props.about?.count3_label}</p>
                </Col>
                <Col md={6} lg={4}>
                  <h5>{props.about?.count4}</h5>
                  <p className="mb-0">{props.about?.count4_label}</p>
                </Col>
                <Col md={6} lg={4}>
                  <h5>{props.about?.count5}</h5>
                  <p className="mb-0">{props.about?.count5_label}</p>
                </Col>
                <Col md={6} lg={4}>
                  <h5>{props.about?.count6}</h5>
                  <p className="mb-0">{props.about?.count6_label}</p>
                </Col>
              </Row>
            </div>
          </Container>
        </div>

        <div className="section section5 bg-repeat bg-size bg-center text-center">
          <Container>
            <div className="bg-white px-3 py-4 p-xl-5">
              <Row className="g-5 justify-content-between">
                <Col lg={6} className="px-lg-5 px-4">
                  <h5 className="text-uppercase">{props.about?.mission_title}</h5>
                  <p>{props.about?.mission_paragraph}</p>
                </Col>
                <Col lg={6} className="px-lg-5 px-4">
                  <h5 className="text-uppercase">{props.about?.vision_title}</h5>
                  <p>{props.about?.vision_paragraph}</p>
                </Col>
              </Row>
            </div>
          </Container>
        </div>

        <div className="section section6">
          <Container>
            <Row className="align-items-center g-4 justify-content-between">
              <Col xl={5} lg={6} className="pe-lg-4">
                {props?.about?.guesswork_image && <img className="guessworkImg img-fluid" src={props?.about?.guesswork_image} alt="" />}
              </Col>
              <Col lg={6}>
                <div className="main__section__div__one">
                  <h3>{props.about?.guesswork_title}</h3>
                  <div className="border border-dark mt-4 mb-lg-5 mb-4" />
                  <div
                    className="about_st"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.about?.guesswork_paragraph),
                    }}
                  />
                  {props?.about?.guesswork_button_title && (
                    <a className="expert" href={props?.about?.guesswork_button_link} target="_blank" rel="noreferrer">
                      <Button className="mt-lg-5 mt-4">{props?.about?.guesswork_button_title}</Button>
                    </a>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="section section7 bg-repeat bg-size bg-center text-center text-white">
          <Container>
            <h6 className="mb-0">{props.about?.clarity_provides_label}</h6>
            <h1 className="my-3 pb-3">{activeTitle?.title}</h1>
            <div className="borderFlex">
              <div className="borderWrap">
                <div className="borderBlue" />
              </div>
            </div>
          </Container>
        </div>

        <section className="section section8">
          <Container>
            <Row className="mb-3 mb-lg-4 mb-xl-5">
              <Col md={10} lg={8} xl={7} className="text-center mx-auto">
                <span className="fw-bold">{props.about?.team_label}</span>
                <h1>{props.about?.team_title}</h1>
                <p className="text-xl">{props.about?.team_paragraph}</p>
                {props?.about?.team_button_label && (
                  <a className="expert btn btn-primary" href={props?.about?.team_button_link} target="_blank" rel="noreferrer">
                    {props?.about?.team_button_label}
                  </a>
                )}
              </Col>
            </Row>
            {props?.about?.team_member?.length > 3 && props?.about?.team_member?.length > 0 && (
              <Slider {...settings} className="card__holder">
                {props?.about?.team_member?.map((team) => (
                  <TeamMember key={team.name} team={team} />
                ))}
              </Slider>
            )}
            {(props?.about?.team_member?.length < 3 || props?.about?.team_member?.length === 3) && props?.about?.team_member?.length > 0 && (
              <>
                <Slider {...settings} className="card__holder d-lg-none">
                  {props?.about?.team_member?.map((team) => (
                    <TeamMember key={team.name} team={team} />
                  ))}
                </Slider>
                <Row className="d-none d-lg-flex justify-content-center gy-3">
                  {props?.about?.team_member?.map((team) => (
                    <Col md={4} key={team.name}>
                      <TeamMember key={team.name} team={team} />
                    </Col>
                  ))}
                </Row>
              </>
            )}
          </Container>
        </section>

        <section className="section section9 bg-repeat bg-size bg-center position-relative">
          <Container>
            <Row>
              <Col xl={5} lg={6}>
                <h1 className="text-white mb-4">{props.about?.take_care_title}</h1>
                <h6 className="text-white mb-5">{props.about?.take_care_sub_title}</h6>
                <a
                  href={`${props?.about?.take_care_button_link || "https://form.jotform.com/213073879005355"}`}
                  target="_blank"
                  className="me-3 mt-2 d-inline-block"
                  rel="noreferrer"
                >
                  <CustomButton variant="rainbow" type="submit" gradient>
                    {props?.about?.take_care_button_label || "Join As A Therapist"}
                  </CustomButton>
                </a>
                <a href={`${props?.about?.vendor_button_link || "https://form.jotform.com/213073879005355"}`} target="_blank" className="mt-2 d-inline-block" rel="noreferrer">
                  <CustomButton variant="rainbow" type="submit" gradient>
                    {props?.about?.vendor_button_title || "Join As A Vendor"}
                  </CustomButton>
                </a>
              </Col>
            </Row>
            {props?.about?.take_care_image && (
              <div className="care-image-wrapper d-none d-lg-block position-absolute top-0 end-0 pt-5 h-100">
                <img className="" src={props?.about?.take_care_image} alt="" />
              </div>
            )}
          </Container>
        </section>
      </div>
      <FooterBottom />
      <SignupModal show={isModal} onHide={() => setIsModal(false)} />
    </>
  );
};

const mapStateToProps = (state) => ({
  about: state.cms.about_data,
});

export default connect(mapStateToProps, {
  getAboutDetailsAction,
})(withRouter(About));
